import { makeGetRequest } from 'owa-ows-gateway';
import { baseUrl } from '../config';
import type { PersonaInfo } from '../../models/PersonaInfo';
import responseConverter from './responseConverter';

type ListContactRequestOptions = {
    expand?: string[];
    count?: number;
    select?: string[];
    filter?: string[];
};

const DefaultExpandOptions = [
    'names',
    'emails',
    'phones',
    'addresses',
    'positions',
    'notes',
    'webAccounts',
    'anniversaries',
    'relationships',
    'websites',
];

const DefaultCountOptions = 1000;

const DefaultSelectOptions = [
    'id',
    'alternateIds',
    'createdDateTime',
    'lastModifiedDateTime',
    'changeKey',
];

const makeQueryString = (
    options: ListContactRequestOptions = {
        expand: DefaultExpandOptions,
        count: DefaultCountOptions,
        select: DefaultSelectOptions,
    }
) => {
    const { expand, count, filter, select } = options;
    let queryString = '?';
    if (expand) {
        queryString += `$expand=${expand.join(',')}&`;
    }
    if (count) {
        queryString += `$top=${count}&`;
    }
    if (select) {
        queryString += `$select=${select.join(',')}&`;
    }
    if (filter) {
        queryString += `$filter=${filter}`;
    }
    return queryString;
};

const listContact = async (
    options: ListContactRequestOptions = {
        expand: DefaultExpandOptions,
        count: DefaultCountOptions,
        select: DefaultSelectOptions,
    }
): Promise<PersonaInfo[] | null> => {
    const queryString = makeQueryString(options);

    const urlToFetch = `${baseUrl}${queryString}`;

    const resp = await makeGetRequest(urlToFetch, undefined, true, null, true);

    const result = await resp.json();

    const convertedResults = responseConverter(result);
    return convertedResults;
};

export default listContact;
